@if (toBattery()) {
    <div class="panel">
        <div class="title">
            <ion-icon class="kwh" src="assets/icon/circle-flash.svg" class="yellow"></ion-icon>
            <label>{{ 'PAGES.HISTORY.TRANSFERRED_TO_GRID' | translate }}</label>
        </div>
        <div class="details">
            <web-fading-span [value]="toBattery() ? 100 - toBattery() : 100" suffix="%"></web-fading-span>
        </div>
    </div>
    <div class="panel">
        <div class="title">
            <ion-icon class="kwh" src="assets/icon/circle-flash.svg" class="green"></ion-icon>
            <label>{{ 'PAGES.HISTORY.TRANSFERRED_TO_BATTERY' | translate }}</label>
        </div>
        <div class="details">
            <web-fading-span [value]="toBattery() ? toBattery() : '-'" suffix="%"></web-fading-span>
        </div>
    </div>
}
@if (solarPanels().length > 1) {
    <hr class="horizontal" />
    @for (panel of solarPanels(); track $index) {
        <div class="panel">
            <div class="title">
                <ion-icon class="kwh" src="assets/icon/circle-flash.svg"></ion-icon>
                <web-device-type-label class="panel-label" [surname]="panel.name" [type]="panel.type" />
            </div>
            <div class="details">
                <web-fading-span
                    [value]="
                        !panel.valueKw.displayed
                            ? '_'
                            : currentUnit() === 'wh'
                              ? panel.valueKw.displayed
                              : panel.valueCurrency
                    "
                    [suffix]="
                        !panel.valueKw.displayed
                            ? ''
                            : currentUnit() === 'wh'
                              ? panel.valueKw.suffix
                              : ('GLOBAL.CURRENCY' | translate)
                    "
                ></web-fading-span>
            </div>
        </div>
    }
}
@if (consomptionData().selfConsoTotal) {
    <div class="panel">
        <div class="title">
            <ion-icon class="kwh" src="assets/icon/circle-flash.svg" class="blue"></ion-icon>
            <label>{{ 'PAGES.HISTORY.AUTOCONSUME_ENERGY' | translate }}</label>
        </div>
        <div class="details">
            <web-fading-span [value]="consomptionData().selfConsoRatio" suffix="%"></web-fading-span>
        </div>
    </div>
    <div class="panel">
        <div class="title">
            <ion-icon class="kwh" src="assets/icon/circle-flash.svg" class="grey"></ion-icon>
            <label>{{ 'PAGES.HISTORY.ENERGY_TAKEN_FROM_NETWORK' | translate }}</label>
        </div>
        <div class="details">
            <web-fading-span [value]="100 - consomptionData().selfConsoRatio" suffix="%"></web-fading-span>
        </div>
    </div>
}
